export default {"src":"/_next/static/image/assets/Illustrations/iconSeek.860e228cd684f861007625f6e2827028.svg","height":16,"width":18};